/**
 * Splits a combined executant entry ("A & B", "A , B") into individual names.
 *
 * Only '&' and ',' are treated as separators. The word "and" is deliberately
 * NOT a separator: committee names legitimately contain it (e.g. "Culture and
 * Sports Committee") and splitting on it would break single identities.
 */
export function splitExecutantNames(raw: string | undefined | null): string[] {
    return (raw ?? '')
        .split(/[&,]/)
        .map(s => s.trim())
        .filter(Boolean);
}

/** Splits a contact field that may hold multiple numbers ("98765..., 91234..."). */
export function splitExecutantNumbers(raw: string | undefined | null): string[] {
    return (raw ?? '')
        .split(/[,/]/)
        .map(s => s.trim())
        .filter(Boolean);
}
